import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
const useStyles = makeStyles({
    table: {
        minWidth: 340,
    },
    root: {
    },
    tableCell: {
        paddingRight: 4,
        paddingLeft: 5
    }
    
});
export default function CustomizedTables(props) {
    const classes = useStyles();
    const {adminData,tableData,setActiveUser} = props;

    return (
        <Grid item xs={12}>
            <Paper className={classes.root}>
                <div className="listing_div">
                    <div className="list_head">
                        <p>
                            <span className="admin-srno" >Sr.No</span>
                            <span className="admin-name" >Username</span>
                            <span className="admin-browser" >Browser</span>
                            <span className="admin-device" >Device</span>
                            <span className="admin-testname" >Test Name</span>
                            <span className="admin-totalquestion" >Total Questions</span>
                        </p>
                    </div>
                    {
                         tableData.length > 0 ?
                            tableData.map((item,index) => {
                                return (
                                <><div key={index + Date.now()} className={index % 2 !== 0 ? "list_even list_name" : "list_odd list_name"}  >
                                <div key={index + Date.now()} className="list_detail_2">
                                <span className="admin-srno"><strong className="viewInMob">Srno : </strong>{index + 1}</span>
                                <span  className="admin-name"><strong className="viewInMob">Username : </strong>{item[1]['username']}</span>
                                <span  className="admin-browser"><strong className="viewInMob">Browser : </strong>{item[1]['browser']}</span>
                                <span  className="admin-device"><strong className="viewInMob">Device : </strong>{item[1]['device']}</span>
                                <span  className="admin-testname"><strong className="viewInMob">Test Name : </strong>{item[1]['testName']}</span>
                                <span  className="admin-totalquestion"><strong className="viewInMob">Total Question : </strong>{item[1]['totalQuestion']}</span>
                                </div>
                                </div>
                                </>);
                                })
                                :
                                <><div className="list_odd list_name" style={{ padding: '0px', lineHeight: '3' }}  >
                                    <div className="list_detail" style={{ textAlign: 'center' }}>
                                        <span style={{ fontSize: '15px', fontWeight: 'bold' }}>No Users Found</span>
                                    </div>
                                </div></>
                    }
                                  </div>
            </Paper>
        </Grid>
    );
}